import { useAppSelector } from '@dealstack/frontend/app/hooks/redux';
import { FGAInternalRole } from '@dealstack/shared/lib/common/fineGrainedAuthorization/permissions';

// The redux user-permissions state types `permissionRole` as PermissionRoleWithOwnerEnum,
// but at runtime it can also hold FGA internal role string values (e.g. dealstackSupport).
// Compare via String() rather than the existing `as unknown as` cast used elsewhere.
const SUPPORT_ROLE_VALUE: string = FGAInternalRole.DEALSTACK_SUPPORT;

export const useIsDealstackSupport = (): boolean => {
	const userData = useAppSelector((state) => state.user.data);

	return (
		userData?.permissions?.some(
			(permission) => String(permission.permissionRole) === SUPPORT_ROLE_VALUE
		) ?? false
	);
};
